import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import AboutSection from './components/AboutSection';
import MethodsSection from './components/MethodsSection';
import ResultsSection from './components/ResultsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../hooks/useSEO';

export default function Home() {
  useSEO({
    title: 'Personal Trainer London | Laura Martin Fitness',
    description:
      "Award-winning personal trainer in London. Expert 1-2-1 PT, online coaching & nutrition. Proven results for clients across London.",
  });

  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Header />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutSection />
        <MethodsSection />
        <ResultsSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
